var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 14,
    height: 22,
    viewBox: "0 0 14 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "location_a",
    d: "M0 .357h13.6V20.4H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 .493)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "location_b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#location_a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.8 1.207a5.957 5.957 0 0 0-5.95 5.95c0 2.28 3.074 7.898 5.95 12.394 1.396-2.183 5.95-9.527 5.95-12.394 0-3.28-2.67-5.95-5.95-5.95M6.798 20.4a.839.839 0 0 1-.456-.134.82.82 0 0 1-.257-.256C4.255 17.15 0 10.173 0 7.157c0-3.749 3.05-6.8 6.8-6.8s6.8 3.051 6.8 6.8c0 3.013-4.255 9.991-6.084 12.852a.854.854 0 0 1-.718.391",
    mask: "url(#location_b)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.8 5.525A2.127 2.127 0 0 0 4.675 7.65c0 1.171.953 2.125 2.125 2.125A2.127 2.127 0 0 0 8.925 7.65 2.127 2.127 0 0 0 6.8 5.525m0 5.1A2.978 2.978 0 0 1 3.825 7.65 2.978 2.978 0 0 1 6.8 4.675 2.978 2.978 0 0 1 9.775 7.65 2.978 2.978 0 0 1 6.8 10.625"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.4b301aa0a59aa2cf316a0491d6c7ca3f.svg";
export { ForwardRef as ReactComponent };